import React from "react"
import classNames from "classnames"

import Menu from "../Menu"

import { getData } from "./data"

import styles from "./styles.module.scss"
import MenuItemCustomTile from "../MenuItemCustomTile"
import FranchiseIcon from "../../assets/FranchiseIcon"
import PriceIcon from "../../assets/PriceIcon"
import {useLocalizationContext} from "../../../../../localization/useLocalizationContext";

interface Props {
	className?: string
}

export default function NavigationMobile(props: Props) {
	const localizationContext = useLocalizationContext();

    const data = getData(localizationContext.locale);

	const businessTypes = data.getBusinessTypes(localizationContext.locale);
	const knowledgeBase = data.getKnowledgeBase(localizationContext.locale);

	return (
		<div className={classNames(props.className)}>
			<div className={styles.navigation__itemTitle}>{"Решения"}</div>
			<Menu composedData={data.solutions} className={styles.navigation__menu} />
			<div className={styles.navigation__itemTitle}>{"Типы бизнеса"}</div>
			<Menu data={businessTypes} className={styles.navigation__menu} />
			<div className={styles.navigation__itemTitle}>{"База знаний"}</div>
			<Menu data={knowledgeBase} className={styles.navigation__menu} />

			<div className={styles.tilesList}>
				<MenuItemCustomTile
					vertical={true}
					className={styles.tiles}
					icon={<FranchiseIcon />}
					title={data.tiles.franchise.title}
					link={data.tiles.franchise.link}
				/>
				<MenuItemCustomTile
					vertical={true}
					className={styles.tiles}
					icon={<PriceIcon />}
					title={data.tiles.price.title}
					link={data.tiles.price.link}
				/>
			</div>
		</div>
	)
}
